import React from "react";

import { SvgIcon, SvgIconProps } from "./SvgIcon";

export const createSvgIcon = (svg: React.ReactElement<React.SVGProps<SVGSVGElement>>) => {
  return ({ ...props }: Omit<SvgIconProps, "children">) => {
    return <SvgIcon {...props}>{svg}</SvgIcon>;
  };
};
